"use client";

import { useEffect, useState } from "react";


import { type GeoDataResponse, fetchGeoData } from "./fetch-geo-data";
import { isStrictUSStateByCode } from "./is-strict-us-state";
import { logError } from "./log-error";

export type GeoData = GeoDataResponse & {
  isDomestic: boolean;
  isIntl: boolean;
  isStrictUSState: boolean;
};

export const useGeoData = () => {
  const [state, setState] = useState<{
    isLoading: boolean;
    didError: boolean;
    data: GeoData | null;
  }>({
    isLoading: true,
    didError: false,
    data: null,
  });

  useEffect(() => {
    const go = async () => {
      setState({
        isLoading: true,
        didError: false,
        data: null,
      });

      const { value, error } = await fetchGeoData();
      if (error) {
        setState({
          isLoading: false,
          didError: true,
          data: null,
        });
        logError({ action: "GEO_DATA_FETCH", error });
      } else {
        const isDomestic = value.country?.isoCode === "US";
        const isIntl = !isDomestic;
        const isStrictUSState =
          isDomestic &&
          value.subdivisions?.some((sub) => isStrictUSStateByCode(sub.isoCode));

        setState({
          isLoading: false,
          didError: false,
          data: {
            ...value,
            isDomestic,
            isIntl,
            isStrictUSState,
          },
        });
      }
    };
    go();
  }, []);

  return state;
};
